/* global moment */
export default function() {
  return date => {
    const momentDate = moment(date);

    if (!date || !momentDate._isValid) {
      return '';
    }

    return momentDate.format('L');
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/PrettyDate.js